import {financialHttp} from './index'

function financialRequest(url, method, data) {
    return financialHttp({
        url: url,
        method: method,
        data: data
    })
}

function get(url, data) {
    return financialRequest(url, 'get', data)
}

function post(url, data) {
    return financialRequest(url, 'post', data)
}


export function productFlowCashSettingList(data) {
    return post('/product/setting/list',data)
}

export function updateProductFlowCashSetting(data) {
    return post('/product/setting/save',data)
}

export function FcMonthDataList(data) {
    return post('/fcmonth/list',data)
}

export function LcProxyMonthDataList(data) {
    return post('/lcproxymonth/list',data)
}

export function rsyncProductFcSetting(data) {
    return post('/product/setting/rsync',data)
}

export function rsyncBusinessDataOperate(lcType, dt) {
    return get(`/finhandle/rsyncdata/${lcType}/${dt}`,{})
}

export function FcMonthRewardsList(data) {
    return post('/fcrewards/list',data)
}

export function updateFcMonthRewards(data) {
    return post('/fcrewards/save',data)
}

export function upload(data) {
    return post('/sharedExpenses/upload', data)
}

export function saveSharedExpenses(data) {
    return post('/sharedExpenses/saveSharedExpenses',data)
}

export function searchSharedExpenses(data) {
    return post('/sharedExpenses/searchSharedExpenses',data)
}

export function saveAppSharedExpenses(data) {
    return post('/sharedExpenses/saveAppSharedExpenses',data)
}

export function searchAppSharedExpenses(data) {
    return post('/sharedExpenses/searchAppSharedExpenses',data)
}

export function searchAppSharedExpensesShare(data) {
    return post('/sharedExpenses/searchAppSharedExpensesShare',data)
}

export function saveFcMonthData(data) {
    return post('/fcmonth/save',data)
}
